import {
  AppConfigInterface,
  CompanyCoreDataInterface,
  CookieConsentConfig,
  PaymentMethodConfigInterface,
  ShippingMethodInterface,
  StaticCmsPage,
  SubscriptionSelectionInterface
} from "@gea-waldviertler-website/gea-models";

const staticCmsPages: StaticCmsPage = {
  "shop-landing": 1333
}

const shippingMethods: ShippingMethodInterface[] = [
  {
    code: "default",
    title: "Standardversand",
    description: "Hermes",
    price: 10,
  },
  {
    code: "spedition",
    title: "Spedition",
    description: "Spedition für Möbel und Matratzen",
    price: 60,
  },
  {
    code: "store",
    title: "Abholung in einer GEA-Filiale",
    description: "Komm bei uns vorbei, um deine Bestellung abzuholen!",
    price: 0,
    // raus: siehe: https://gitlab.gea.at/gea-waldviertler-website/angular-webshop/-/issues/115
    // selections: [],
    // activeSelection: undefined
  }, {
    code: 'buildup',
    title: "Aufbauservice",
    description: "Wir bauen deine Möbel zuhause auf!",
    price: 90
  }
]

const paymentMethods: PaymentMethodConfigInterface[] = [
  {
    title: "Paypal",
    code: "paypal",
  }, {
    title: 'Kreditkarte',
    code: 'creditcard',
  }, {
    title: "EPS",
    code: "eps"
  }, {
    title: "Vorkasse",
    code: "prepayment"
  }, {
    title: "Ohne Zahlung",
    code: "free"
  }
]

const cookieConsentConfig: CookieConsentConfig = {
  version: 5,
  ttl: 15768000, // half year
  title: "Datenschutz & Cookies",
  description: "Wir freuen uns über deinen Besuch auf unserer Website!<br><br>Die sogenannte EU-Cookie-Richtlinie verlangt, dass wir dich über die Nutzung von Cookies informieren. Dein Besuch erfordert, dass sich dein Browser technisch notwendige Informationen (Cookies) merkt, um unsere Website verwenden zu können.<br><br>Wir sind bemüht, deinen Besuch und deinen Einkauf so komfortabel wie möglich zu gestalten. Dafür nutzen wir auch nicht-technische, funktionale Cookies um unsere Website laufend optimieren zu können.<br><br>Da wir großen Wert auf Datenschutz legen, nutzen wir dafür ausschließlich quelloffene Analysewerkzeuge, welche wir auf unseren eigenen Servern in Schrems in Niederösterreich und Wien betreiben. Wir verlassen uns nicht auf die Versprechen der Internetriesen und geben daher keine Daten an Dritte weiter.<br><br><strong>Diese Website verwendet keine Cookies von Drittanbietern</strong>.",
  groups: [
    {
      "identifier": "gea-internal",
      "title": "GEA Analyse",
      "description": 'Tools zur internen Auswertung. Um die Website zu verbessern, sammeln wir anonyme Daten vom Benutzerverhalten. Diese Informationen werden ausschließlich firmenintern verwendet.',
      "scopes": [
        "gea-analytics"
      ]
    }
  ],
  scopes: {
    "gea-analytics": {
      "title": "Gea Intern",
      "description": 'Wir verwenden die quelloffene Software "Matomo", mit der nur wir die gesammelten Daten einsehen können. Weiterführende Informationen dazu findest du hier: <a target="_blank" href="https://matomo.org/" rel="nofollow, noopener">» Matomo</a><br><br>Die Einstellungen lassen sich jederzeit über den Link "Cookie-Einstellungen" ganz unten auf der Seite anpassen.',
      "link": "https://gea-waldviertler.at/datenschutzerklaerung/"
    }
  }
}

const companyCoreData: CompanyCoreDataInterface = {
  banking: {
    name: "Waldviertler Werkstätten GmbH",
    iban: "AT423241500000058750",
    bic: "RLNWATWWOWS",
    bank: "Raiffeisenbank Oberes Waldviertel eGen"
  }
}

const subscribeItems: SubscriptionSelectionInterface[] = [
  { code: "newsletter", title: "GEA Newsletter", checked: false, type: 'email' },
  { code: "brennstoff", title: "Brennstoff", checked: false, type: 'postal' },
  { code: "album", title: "Album", checked: false, type: 'postal' },
]

export const sharedEnvironment: Partial<AppConfigInterface> = {
  captchaKey: 'FCMM3JIHN6HF7PBJ',
  elasticsearchUrl: '/shop/elasticsearch/',
  staticCmsPages: staticCmsPages,
  shippingMethods: shippingMethods,
  paymentMethods: paymentMethods,
  googleApiKey: "AIzaSyAT5l4GalaEKNozq6yoewf5yoEqMDmVAW8",
  clientAppVersion:  require('../../package.json').version,
  pageTitleSuffix: ' • GEA Waldviertler Webshop',
  cookieConsentConfig: cookieConsentConfig,
  companyCoreData: companyCoreData,
  subscribeItems: subscribeItems,
  debug: {},
}